import { IKnoOrganisationAdminLevel } from 'APIPackage/CatalogsModule/interfaces/IKnoOrganisationAdminLevel';

import { IKnoAdminLevelSelectOption } from '../interfaces/IKnoAdminLevelSelectOption';

export const createKnoAdminLevelSelectOption = (
  knoAdminLevel: IKnoOrganisationAdminLevel,
): IKnoAdminLevelSelectOption => ({
  ...knoAdminLevel,
  label: knoAdminLevel.title,
  value: knoAdminLevel.title,
});
